/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Configuration } from "../configuration";
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from "axios";
import globalAxios from "axios";
import { useAuthStore } from "@/stores/auth";
import { useClient } from "@/composables/useClient";
import { useNotificationStore } from "@/stores/notification";
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
  propertyMeta,
  MetaTypesBase,
} from "../common";
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  type RequestArgs,
  BaseAPI,
  RequiredError,
  operationServerMap,
} from "../base";
// @ts-ignore
import type { ApClassInstanceDTO } from "../model";
import { ApClassInstanceDTOTrackedI, ApClassInstanceDTOMeta } from "../model";
// @ts-ignore
import type { ClassFilterOptions } from "../model";
import { ClassFilterOptionsTrackedI, ClassFilterOptionsMeta } from "../model";
// @ts-ignore
import type { ClassInstanceDTO } from "../model";
import { ClassInstanceDTOTrackedI, ClassInstanceDTOMeta } from "../model";
// @ts-ignore
import type { ClassSignupRequestDTO } from "../model";
import {
  ClassSignupRequestDTOTrackedI,
  ClassSignupRequestDTOMeta,
} from "../model";
// @ts-ignore
import type { ClassSignupResponseDTO } from "../model";
import {
  ClassSignupResponseDTOTrackedI,
  ClassSignupResponseDTOMeta,
} from "../model";
// @ts-ignore
import type { ClassWithEligibilityDTO } from "../model";
import {
  ClassWithEligibilityDTOTrackedI,
  ClassWithEligibilityDTOMeta,
} from "../model";
// @ts-ignore
import type { ClassWithEligibilitySingularDTO } from "../model";
import {
  ClassWithEligibilitySingularDTOTrackedI,
  ClassWithEligibilitySingularDTOMeta,
} from "../model";
// @ts-ignore
import type { GuidedSailCreateInstanceResult } from "../model";
import {
  GuidedSailCreateInstanceResultTrackedI,
  GuidedSailCreateInstanceResultMeta,
} from "../model";
// @ts-ignore
import type { GuidedSailTimeSlotsForDayDTO } from "../model";
import {
  GuidedSailTimeSlotsForDayDTOTrackedI,
  GuidedSailTimeSlotsForDayDTOMeta,
} from "../model";
// @ts-ignore
import type { InstructorEnrollmentRequestDTO } from "../model";
import {
  InstructorEnrollmentRequestDTOTrackedI,
  InstructorEnrollmentRequestDTOMeta,
} from "../model";
// @ts-ignore
import type { JpClassSectionDTO } from "../model";
import { JpClassSectionDTOTrackedI, JpClassSectionDTOMeta } from "../model";
// @ts-ignore
import type { StaffClassSignupRequestDTO } from "../model";
import {
  StaffClassSignupRequestDTOTrackedI,
  StaffClassSignupRequestDTOMeta,
} from "../model";
// @ts-ignore
import type { StaffClassesResponseDTO } from "../model";
import {
  StaffClassesResponseDTOTrackedI,
  StaffClassesResponseDTOMeta,
} from "../model";
// @ts-ignore
import type { StaffInstructorEnrollmentRequestDTO } from "../model";
import {
  StaffInstructorEnrollmentRequestDTOTrackedI,
  StaffInstructorEnrollmentRequestDTOMeta,
} from "../model";
// @ts-ignore
import type { StaffProcessWaitlistOffersRequestDTO } from "../model";
import {
  StaffProcessWaitlistOffersRequestDTOTrackedI,
  StaffProcessWaitlistOffersRequestDTOMeta,
} from "../model";
import { applyTransform } from "@/api/mappers/dtoDateMapper";
import { PaginatedResults } from "@/api/models/PaginatedResults";
/**
 * UnifiedClassApi - axios parameter creator
 * @export
 */
export const UnifiedClassApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     * Gets ao class instances
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apClassInstancesGet: (options: RawAxiosRequestConfig = {}): RequestArgs => {
      const localVarPath = `/ap-class-instances`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Gets jp class sections
     * @param {string} startDate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    jpClassSectionsGet: (
      startDate: string,
      options: RawAxiosRequestConfig = {},
    ): RequestArgs => {
      // verify required parameter 'startDate' is not null or undefined
      assertParamExists("jpClassSectionsGet", "startDate", startDate);
      const localVarPath = `/jp-class-sections`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;
      if (startDate !== undefined) {
        localVarQueryParameter["startDate"] = startDate;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Enroll as instructor for a class
     * @param {InstructorEnrollmentRequestDTO} instructorEnrollmentRequestDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    memberClassesInstructorEnrollPost: (
      instructorEnrollmentRequestDTO: InstructorEnrollmentRequestDTO,
      options: RawAxiosRequestConfig = {},
    ): RequestArgs => {
      // verify required parameter 'instructorEnrollmentRequestDTO' is not null or undefined
      assertParamExists(
        "memberClassesInstructorEnrollPost",
        "instructorEnrollmentRequestDTO",
        instructorEnrollmentRequestDTO,
      );
      const localVarPath = `/member/classes/instructor/enroll`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        instructorEnrollmentRequestDTO,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Unenroll as instructor from a class
     * @param {InstructorEnrollmentRequestDTO} instructorEnrollmentRequestDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    memberClassesInstructorUnenrollPost: (
      instructorEnrollmentRequestDTO: InstructorEnrollmentRequestDTO,
      options: RawAxiosRequestConfig = {},
    ): RequestArgs => {
      // verify required parameter 'instructorEnrollmentRequestDTO' is not null or undefined
      assertParamExists(
        "memberClassesInstructorUnenrollPost",
        "instructorEnrollmentRequestDTO",
        instructorEnrollmentRequestDTO,
      );
      const localVarPath = `/member/classes/instructor/unenroll`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        instructorEnrollmentRequestDTO,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Gets all classes with eligibility and signups
     * @param {ClassFilterOptions} classFilterOptions
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    memberClassesPost: (
      classFilterOptions: ClassFilterOptions,
      options: RawAxiosRequestConfig = {},
    ): RequestArgs => {
      // verify required parameter 'classFilterOptions' is not null or undefined
      assertParamExists(
        "memberClassesPost",
        "classFilterOptions",
        classFilterOptions,
      );
      const localVarPath = `/member/classes`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        classFilterOptions,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Signs up for a class
     * @param {ClassSignupRequestDTO} classSignupRequestDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    memberClassesSignupPost: (
      classSignupRequestDTO: ClassSignupRequestDTO,
      options: RawAxiosRequestConfig = {},
    ): RequestArgs => {
      // verify required parameter 'classSignupRequestDTO' is not null or undefined
      assertParamExists(
        "memberClassesSignupPost",
        "classSignupRequestDTO",
        classSignupRequestDTO,
      );
      const localVarPath = `/member/classes/signup`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        classSignupRequestDTO,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Create a guided sail instance for a specific timeslot
     * @param {string} timeslot
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    memberGuidedSailCreateTimeslotPost: (
      timeslot: string,
      options: RawAxiosRequestConfig = {},
    ): RequestArgs => {
      // verify required parameter 'timeslot' is not null or undefined
      assertParamExists(
        "memberGuidedSailCreateTimeslotPost",
        "timeslot",
        timeslot,
      );
      const localVarPath = `/member/guided-sail/create/{timeslot}`.replace(
        `{${"timeslot"}}`,
        encodeURIComponent(String(timeslot)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Get available guided sail time slots for a given month
     * @param {number} year
     * @param {number} month
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    memberGuidedSailTimeslotsYearMonthGet: (
      year: number,
      month: number,
      options: RawAxiosRequestConfig = {},
    ): RequestArgs => {
      // verify required parameter 'year' is not null or undefined
      assertParamExists("memberGuidedSailTimeslotsYearMonthGet", "year", year);
      // verify required parameter 'month' is not null or undefined
      assertParamExists(
        "memberGuidedSailTimeslotsYearMonthGet",
        "month",
        month,
      );
      const localVarPath = `/member/guided-sail/timeslots/{year}/{month}`
        .replace(`{${"year"}}`, encodeURIComponent(String(year)))
        .replace(`{${"month"}}`, encodeURIComponent(String(month)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Gets all classes
     * @param {ClassFilterOptions} classFilterOptions
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    publicClassesPost: (
      classFilterOptions: ClassFilterOptions,
      options: RawAxiosRequestConfig = {},
    ): RequestArgs => {
      // verify required parameter 'classFilterOptions' is not null or undefined
      assertParamExists(
        "publicClassesPost",
        "classFilterOptions",
        classFilterOptions,
      );
      const localVarPath = `/public/classes`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        classFilterOptions,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Enroll a person as instructor for a class (staff)
     * @param {StaffInstructorEnrollmentRequestDTO} staffInstructorEnrollmentRequestDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    staffClassesInstructorEnrollPost: (
      staffInstructorEnrollmentRequestDTO: StaffInstructorEnrollmentRequestDTO,
      options: RawAxiosRequestConfig = {},
    ): RequestArgs => {
      // verify required parameter 'staffInstructorEnrollmentRequestDTO' is not null or undefined
      assertParamExists(
        "staffClassesInstructorEnrollPost",
        "staffInstructorEnrollmentRequestDTO",
        staffInstructorEnrollmentRequestDTO,
      );
      const localVarPath = `/staff/classes/instructor/enroll`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        staffInstructorEnrollmentRequestDTO,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Unenroll a person as instructor from a class (staff)
     * @param {StaffInstructorEnrollmentRequestDTO} staffInstructorEnrollmentRequestDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    staffClassesInstructorUnenrollPost: (
      staffInstructorEnrollmentRequestDTO: StaffInstructorEnrollmentRequestDTO,
      options: RawAxiosRequestConfig = {},
    ): RequestArgs => {
      // verify required parameter 'staffInstructorEnrollmentRequestDTO' is not null or undefined
      assertParamExists(
        "staffClassesInstructorUnenrollPost",
        "staffInstructorEnrollmentRequestDTO",
        staffInstructorEnrollmentRequestDTO,
      );
      const localVarPath = `/staff/classes/instructor/unenroll`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        staffInstructorEnrollmentRequestDTO,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Gets all classes with eligibility and signups
     * @param {number} personId
     * @param {ClassFilterOptions} classFilterOptions
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    staffClassesPersonIdPost: (
      personId: number,
      classFilterOptions: ClassFilterOptions,
      options: RawAxiosRequestConfig = {},
    ): RequestArgs => {
      // verify required parameter 'personId' is not null or undefined
      assertParamExists("staffClassesPersonIdPost", "personId", personId);
      // verify required parameter 'classFilterOptions' is not null or undefined
      assertParamExists(
        "staffClassesPersonIdPost",
        "classFilterOptions",
        classFilterOptions,
      );
      const localVarPath = `/staff/classes/{personId}`.replace(
        `{${"personId"}}`,
        encodeURIComponent(String(personId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        classFilterOptions,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Gets all classes with availability (no person eligibility)
     * @param {ClassFilterOptions} classFilterOptions
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    staffClassesPost: (
      classFilterOptions: ClassFilterOptions,
      options: RawAxiosRequestConfig = {},
    ): RequestArgs => {
      // verify required parameter 'classFilterOptions' is not null or undefined
      assertParamExists(
        "staffClassesPost",
        "classFilterOptions",
        classFilterOptions,
      );
      const localVarPath = `/staff/classes`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        classFilterOptions,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Signs up for a class
     * @param {StaffProcessWaitlistOffersRequestDTO} staffProcessWaitlistOffersRequestDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    staffClassesProcessWaitlistOffersPost: (
      staffProcessWaitlistOffersRequestDTO: StaffProcessWaitlistOffersRequestDTO,
      options: RawAxiosRequestConfig = {},
    ): RequestArgs => {
      // verify required parameter 'staffProcessWaitlistOffersRequestDTO' is not null or undefined
      assertParamExists(
        "staffClassesProcessWaitlistOffersPost",
        "staffProcessWaitlistOffersRequestDTO",
        staffProcessWaitlistOffersRequestDTO,
      );
      const localVarPath = `/staff/classes/processWaitlistOffers`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        staffProcessWaitlistOffersRequestDTO,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Signs up for a class
     * @param {StaffClassSignupRequestDTO} staffClassSignupRequestDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    staffClassesSignupPost: (
      staffClassSignupRequestDTO: StaffClassSignupRequestDTO,
      options: RawAxiosRequestConfig = {},
    ): RequestArgs => {
      // verify required parameter 'staffClassSignupRequestDTO' is not null or undefined
      assertParamExists(
        "staffClassesSignupPost",
        "staffClassSignupRequestDTO",
        staffClassSignupRequestDTO,
      );
      const localVarPath = `/staff/classes/signup`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        staffClassSignupRequestDTO,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Create a guided sail instance for a specific timeslot
     * @param {string} timeslot
     * @param {number} personId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    staffGuidedSailCreateTimeslotPersonIdPost: (
      timeslot: string,
      personId: number,
      options: RawAxiosRequestConfig = {},
    ): RequestArgs => {
      // verify required parameter 'timeslot' is not null or undefined
      assertParamExists(
        "staffGuidedSailCreateTimeslotPersonIdPost",
        "timeslot",
        timeslot,
      );
      // verify required parameter 'personId' is not null or undefined
      assertParamExists(
        "staffGuidedSailCreateTimeslotPersonIdPost",
        "personId",
        personId,
      );
      const localVarPath = `/staff/guided-sail/create/{timeslot}/{personId}`
        .replace(`{${"timeslot"}}`, encodeURIComponent(String(timeslot)))
        .replace(`{${"personId"}}`, encodeURIComponent(String(personId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Get available guided sail time slots for a given month
     * @param {number} year
     * @param {number} month
     * @param {number} personId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    staffGuidedSailTimeslotsYearMonthPersonIdGet: (
      year: number,
      month: number,
      personId: number,
      options: RawAxiosRequestConfig = {},
    ): RequestArgs => {
      // verify required parameter 'year' is not null or undefined
      assertParamExists(
        "staffGuidedSailTimeslotsYearMonthPersonIdGet",
        "year",
        year,
      );
      // verify required parameter 'month' is not null or undefined
      assertParamExists(
        "staffGuidedSailTimeslotsYearMonthPersonIdGet",
        "month",
        month,
      );
      // verify required parameter 'personId' is not null or undefined
      assertParamExists(
        "staffGuidedSailTimeslotsYearMonthPersonIdGet",
        "personId",
        personId,
      );
      const localVarPath =
        `/staff/guided-sail/timeslots/{year}/{month}/{personId}`
          .replace(`{${"year"}}`, encodeURIComponent(String(year)))
          .replace(`{${"month"}}`, encodeURIComponent(String(month)))
          .replace(`{${"personId"}}`, encodeURIComponent(String(personId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

export type apClassInstancesGetParams = {};
export type jpClassSectionsGetParams = { startDate: string };
export type memberClassesInstructorEnrollPostParams = {
  instructorEnrollmentRequestDTO: InstructorEnrollmentRequestDTO;
};
export type memberClassesInstructorUnenrollPostParams = {
  instructorEnrollmentRequestDTO: InstructorEnrollmentRequestDTO;
};
export type memberClassesPostParams = {
  classFilterOptions: ClassFilterOptions;
};
export type memberClassesSignupPostParams = {
  classSignupRequestDTO: ClassSignupRequestDTO;
};
export type memberGuidedSailCreateTimeslotPostParams = { timeslot: string };
export type memberGuidedSailTimeslotsYearMonthGetParams = {
  year: number;
  month: number;
};
export type publicClassesPostParams = {
  classFilterOptions: ClassFilterOptions;
};
export type staffClassesInstructorEnrollPostParams = {
  staffInstructorEnrollmentRequestDTO: StaffInstructorEnrollmentRequestDTO;
};
export type staffClassesInstructorUnenrollPostParams = {
  staffInstructorEnrollmentRequestDTO: StaffInstructorEnrollmentRequestDTO;
};
export type staffClassesPersonIdPostParams = {
  personId: number;
  classFilterOptions: ClassFilterOptions;
};
export type staffClassesPostParams = { classFilterOptions: ClassFilterOptions };
export type staffClassesProcessWaitlistOffersPostParams = {
  staffProcessWaitlistOffersRequestDTO: StaffProcessWaitlistOffersRequestDTO;
};
export type staffClassesSignupPostParams = {
  staffClassSignupRequestDTO: StaffClassSignupRequestDTO;
};
export type staffGuidedSailCreateTimeslotPersonIdPostParams = {
  timeslot: string;
  personId: number;
};
export type staffGuidedSailTimeslotsYearMonthPersonIdGetParams = {
  year: number;
  month: number;
  personId: number;
};

export const apClassInstancesGetMeta = {};
export const jpClassSectionsGetMeta = {
  startDate: propertyMeta(
    "startDate",
    false,
    true,
    false,
    MetaTypesBase.string,
  ),
};
export const memberClassesInstructorEnrollPostMeta = {
  instructorEnrollmentRequestDTO: propertyMeta(
    "instructorEnrollmentRequestDTO",
    false,
    true,
    false,
    InstructorEnrollmentRequestDTOMeta,
  ),
};
export const memberClassesInstructorUnenrollPostMeta = {
  instructorEnrollmentRequestDTO: propertyMeta(
    "instructorEnrollmentRequestDTO",
    false,
    true,
    false,
    InstructorEnrollmentRequestDTOMeta,
  ),
};
export const memberClassesPostMeta = {
  classFilterOptions: propertyMeta(
    "classFilterOptions",
    false,
    true,
    false,
    ClassFilterOptionsMeta,
  ),
};
export const memberClassesSignupPostMeta = {
  classSignupRequestDTO: propertyMeta(
    "classSignupRequestDTO",
    false,
    true,
    false,
    ClassSignupRequestDTOMeta,
  ),
};
export const memberGuidedSailCreateTimeslotPostMeta = {
  timeslot: propertyMeta("timeslot", false, true, false, MetaTypesBase.string),
};
export const memberGuidedSailTimeslotsYearMonthGetMeta = {
  year: propertyMeta("year", false, true, false, MetaTypesBase.number),
  month: propertyMeta("month", false, true, false, MetaTypesBase.number),
};
export const publicClassesPostMeta = {
  classFilterOptions: propertyMeta(
    "classFilterOptions",
    false,
    true,
    false,
    ClassFilterOptionsMeta,
  ),
};
export const staffClassesInstructorEnrollPostMeta = {
  staffInstructorEnrollmentRequestDTO: propertyMeta(
    "staffInstructorEnrollmentRequestDTO",
    false,
    true,
    false,
    StaffInstructorEnrollmentRequestDTOMeta,
  ),
};
export const staffClassesInstructorUnenrollPostMeta = {
  staffInstructorEnrollmentRequestDTO: propertyMeta(
    "staffInstructorEnrollmentRequestDTO",
    false,
    true,
    false,
    StaffInstructorEnrollmentRequestDTOMeta,
  ),
};
export const staffClassesPersonIdPostMeta = {
  personId: propertyMeta("personId", false, true, false, MetaTypesBase.number),
  classFilterOptions: propertyMeta(
    "classFilterOptions",
    false,
    true,
    false,
    ClassFilterOptionsMeta,
  ),
};
export const staffClassesPostMeta = {
  classFilterOptions: propertyMeta(
    "classFilterOptions",
    false,
    true,
    false,
    ClassFilterOptionsMeta,
  ),
};
export const staffClassesProcessWaitlistOffersPostMeta = {
  staffProcessWaitlistOffersRequestDTO: propertyMeta(
    "staffProcessWaitlistOffersRequestDTO",
    false,
    true,
    false,
    StaffProcessWaitlistOffersRequestDTOMeta,
  ),
};
export const staffClassesSignupPostMeta = {
  staffClassSignupRequestDTO: propertyMeta(
    "staffClassSignupRequestDTO",
    false,
    true,
    false,
    StaffClassSignupRequestDTOMeta,
  ),
};
export const staffGuidedSailCreateTimeslotPersonIdPostMeta = {
  timeslot: propertyMeta("timeslot", false, true, false, MetaTypesBase.string),
  personId: propertyMeta("personId", false, true, false, MetaTypesBase.number),
};
export const staffGuidedSailTimeslotsYearMonthPersonIdGetMeta = {
  year: propertyMeta("year", false, true, false, MetaTypesBase.number),
  month: propertyMeta("month", false, true, false, MetaTypesBase.number),
  personId: propertyMeta("personId", false, true, false, MetaTypesBase.number),
};

/**
 * UnifiedClassApi - functional programming interface
 * @export
 */
export const useUnifiedClassApi = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    UnifiedClassApiAxiosParamCreator(configuration);
  const client = useClient();
  const authStore = useAuthStore();
  const notificationStore = useNotificationStore();
  return {
    /**
     * Gets ao class instances
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apClassInstancesGetRaw(
      props: apClassInstancesGetParams,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<ApClassInstanceDTO>> {
      const localVarAxiosArgs =
        localVarAxiosParamCreator.apClassInstancesGet(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["UnifiedClassApi.apClassInstancesGet"]?.[
          localVarOperationServerIndex
        ]?.url;
      return createRequestFunction<Array<ApClassInstanceDTO>>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client)
        .then((res) => {
          applyTransform("Array<ApClassInstanceDTO>", res.data);
          return res;
        })
        .catch((a) => {
          notificationStore.evalErrorMessage(
            a,
            "An internal error has occured, please try again and contact us if the issue is not resolved!",
          );
          return a;
        });
    },
    /**
     * Gets jp class sections
     * @param {string} startDate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    jpClassSectionsGetRaw(
      props: jpClassSectionsGetParams,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<JpClassSectionDTO>> {
      const localVarAxiosArgs = localVarAxiosParamCreator.jpClassSectionsGet(
        props.startDate,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["UnifiedClassApi.jpClassSectionsGet"]?.[
          localVarOperationServerIndex
        ]?.url;
      return createRequestFunction<Array<JpClassSectionDTO>>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client)
        .then((res) => {
          applyTransform("Array<JpClassSectionDTO>", res.data);
          return res;
        })
        .catch((a) => {
          notificationStore.evalErrorMessage(
            a,
            "An internal error has occured, please try again and contact us if the issue is not resolved!",
          );
          return a;
        });
    },
    /**
     * Enroll as instructor for a class
     * @param {InstructorEnrollmentRequestDTO} instructorEnrollmentRequestDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    memberClassesInstructorEnrollPostRaw(
      props: memberClassesInstructorEnrollPostParams,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<string> {
      authStore.requireAuth([
        // authentication member required
        "member",
      ]);
      const localVarAxiosArgs =
        localVarAxiosParamCreator.memberClassesInstructorEnrollPost(
          props.instructorEnrollmentRequestDTO,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          "UnifiedClassApi.memberClassesInstructorEnrollPost"
        ]?.[localVarOperationServerIndex]?.url;
      return createRequestFunction<string>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client)
        .then((res) => {
          applyTransform("string", res.data);
          return res;
        })
        .catch((a) => {
          notificationStore.evalErrorMessage(
            a,
            "An internal error has occured, please try again and contact us if the issue is not resolved!",
          );
          return a;
        });
    },
    /**
     * Unenroll as instructor from a class
     * @param {InstructorEnrollmentRequestDTO} instructorEnrollmentRequestDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    memberClassesInstructorUnenrollPostRaw(
      props: memberClassesInstructorUnenrollPostParams,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<string> {
      authStore.requireAuth([
        // authentication member required
        "member",
      ]);
      const localVarAxiosArgs =
        localVarAxiosParamCreator.memberClassesInstructorUnenrollPost(
          props.instructorEnrollmentRequestDTO,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          "UnifiedClassApi.memberClassesInstructorUnenrollPost"
        ]?.[localVarOperationServerIndex]?.url;
      return createRequestFunction<string>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client)
        .then((res) => {
          applyTransform("string", res.data);
          return res;
        })
        .catch((a) => {
          notificationStore.evalErrorMessage(
            a,
            "An internal error has occured, please try again and contact us if the issue is not resolved!",
          );
          return a;
        });
    },
    /**
     * Gets all classes with eligibility and signups
     * @param {ClassFilterOptions} classFilterOptions
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    memberClassesPostRaw(
      props: memberClassesPostParams,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<ClassWithEligibilityDTO>> {
      authStore.requireAuth([
        // authentication member required
        "member",
      ]);
      const localVarAxiosArgs = localVarAxiosParamCreator.memberClassesPost(
        props.classFilterOptions,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["UnifiedClassApi.memberClassesPost"]?.[
          localVarOperationServerIndex
        ]?.url;
      return createRequestFunction<Array<ClassWithEligibilityDTO>>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client)
        .then((res) => {
          applyTransform("Array<ClassWithEligibilityDTO>", res.data);
          return res;
        })
        .catch((a) => {
          notificationStore.evalErrorMessage(
            a,
            "An internal error has occured, please try again and contact us if the issue is not resolved!",
          );
          return a;
        });
    },
    /**
     * Signs up for a class
     * @param {ClassSignupRequestDTO} classSignupRequestDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    memberClassesSignupPostRaw(
      props: memberClassesSignupPostParams,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ClassSignupResponseDTO> {
      authStore.requireAuth([
        // authentication member required
        "member",
      ]);
      const localVarAxiosArgs =
        localVarAxiosParamCreator.memberClassesSignupPost(
          props.classSignupRequestDTO,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["UnifiedClassApi.memberClassesSignupPost"]?.[
          localVarOperationServerIndex
        ]?.url;
      return createRequestFunction<ClassSignupResponseDTO>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client)
        .then((res) => {
          applyTransform("ClassSignupResponseDTO", res.data);
          return res;
        })
        .catch((a) => {
          notificationStore.evalErrorMessage(
            a,
            "An internal error has occured, please try again and contact us if the issue is not resolved!",
          );
          return a;
        });
    },
    /**
     * Create a guided sail instance for a specific timeslot
     * @param {string} timeslot
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    memberGuidedSailCreateTimeslotPostRaw(
      props: memberGuidedSailCreateTimeslotPostParams,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<GuidedSailCreateInstanceResult> {
      authStore.requireAuth([
        // authentication member required
        "member",
      ]);
      const localVarAxiosArgs =
        localVarAxiosParamCreator.memberGuidedSailCreateTimeslotPost(
          props.timeslot,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          "UnifiedClassApi.memberGuidedSailCreateTimeslotPost"
        ]?.[localVarOperationServerIndex]?.url;
      return createRequestFunction<GuidedSailCreateInstanceResult>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client)
        .then((res) => {
          applyTransform("GuidedSailCreateInstanceResult", res.data);
          return res;
        })
        .catch((a) => {
          notificationStore.evalErrorMessage(
            a,
            "An internal error has occured, please try again and contact us if the issue is not resolved!",
          );
          return a;
        });
    },
    /**
     * Get available guided sail time slots for a given month
     * @param {number} year
     * @param {number} month
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    memberGuidedSailTimeslotsYearMonthGetRaw(
      props: memberGuidedSailTimeslotsYearMonthGetParams,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<GuidedSailTimeSlotsForDayDTO>> {
      authStore.requireAuth([
        // authentication member required
        "member",
      ]);
      const localVarAxiosArgs =
        localVarAxiosParamCreator.memberGuidedSailTimeslotsYearMonthGet(
          props.year,
          props.month,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          "UnifiedClassApi.memberGuidedSailTimeslotsYearMonthGet"
        ]?.[localVarOperationServerIndex]?.url;
      return createRequestFunction<Array<GuidedSailTimeSlotsForDayDTO>>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client)
        .then((res) => {
          applyTransform("Array<GuidedSailTimeSlotsForDayDTO>", res.data);
          return res;
        })
        .catch((a) => {
          notificationStore.evalErrorMessage(
            a,
            "An internal error has occured, please try again and contact us if the issue is not resolved!",
          );
          return a;
        });
    },
    /**
     * Gets all classes
     * @param {ClassFilterOptions} classFilterOptions
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    publicClassesPostRaw(
      props: publicClassesPostParams,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<ClassInstanceDTO>> {
      const localVarAxiosArgs = localVarAxiosParamCreator.publicClassesPost(
        props.classFilterOptions,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["UnifiedClassApi.publicClassesPost"]?.[
          localVarOperationServerIndex
        ]?.url;
      return createRequestFunction<Array<ClassInstanceDTO>>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client)
        .then((res) => {
          applyTransform("Array<ClassInstanceDTO>", res.data);
          return res;
        })
        .catch((a) => {
          notificationStore.evalErrorMessage(
            a,
            "An internal error has occured, please try again and contact us if the issue is not resolved!",
          );
          return a;
        });
    },
    /**
     * Enroll a person as instructor for a class (staff)
     * @param {StaffInstructorEnrollmentRequestDTO} staffInstructorEnrollmentRequestDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    staffClassesInstructorEnrollPostRaw(
      props: staffClassesInstructorEnrollPostParams,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<string> {
      authStore.requireAuth([
        // authentication staff required
        "staff",
      ]);
      const localVarAxiosArgs =
        localVarAxiosParamCreator.staffClassesInstructorEnrollPost(
          props.staffInstructorEnrollmentRequestDTO,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          "UnifiedClassApi.staffClassesInstructorEnrollPost"
        ]?.[localVarOperationServerIndex]?.url;
      return createRequestFunction<string>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client)
        .then((res) => {
          applyTransform("string", res.data);
          return res;
        })
        .catch((a) => {
          notificationStore.evalErrorMessage(
            a,
            "An internal error has occured, please try again and contact us if the issue is not resolved!",
          );
          return a;
        });
    },
    /**
     * Unenroll a person as instructor from a class (staff)
     * @param {StaffInstructorEnrollmentRequestDTO} staffInstructorEnrollmentRequestDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    staffClassesInstructorUnenrollPostRaw(
      props: staffClassesInstructorUnenrollPostParams,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<string> {
      authStore.requireAuth([
        // authentication staff required
        "staff",
      ]);
      const localVarAxiosArgs =
        localVarAxiosParamCreator.staffClassesInstructorUnenrollPost(
          props.staffInstructorEnrollmentRequestDTO,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          "UnifiedClassApi.staffClassesInstructorUnenrollPost"
        ]?.[localVarOperationServerIndex]?.url;
      return createRequestFunction<string>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client)
        .then((res) => {
          applyTransform("string", res.data);
          return res;
        })
        .catch((a) => {
          notificationStore.evalErrorMessage(
            a,
            "An internal error has occured, please try again and contact us if the issue is not resolved!",
          );
          return a;
        });
    },
    /**
     * Gets all classes with eligibility and signups
     * @param {number} personId
     * @param {ClassFilterOptions} classFilterOptions
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    staffClassesPersonIdPostRaw(
      props: staffClassesPersonIdPostParams,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<ClassWithEligibilitySingularDTO>> {
      authStore.requireAuth([
        // authentication staff required
        "staff",
      ]);
      const localVarAxiosArgs =
        localVarAxiosParamCreator.staffClassesPersonIdPost(
          props.personId,
          props.classFilterOptions,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["UnifiedClassApi.staffClassesPersonIdPost"]?.[
          localVarOperationServerIndex
        ]?.url;
      return createRequestFunction<Array<ClassWithEligibilitySingularDTO>>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client)
        .then((res) => {
          applyTransform("Array<ClassWithEligibilitySingularDTO>", res.data);
          return res;
        })
        .catch((a) => {
          notificationStore.evalErrorMessage(
            a,
            "An internal error has occured, please try again and contact us if the issue is not resolved!",
          );
          return a;
        });
    },
    /**
     * Gets all classes with availability (no person eligibility)
     * @param {ClassFilterOptions} classFilterOptions
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    staffClassesPostRaw(
      props: staffClassesPostParams,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<StaffClassesResponseDTO> {
      authStore.requireAuth([
        // authentication staff required
        "staff",
      ]);
      const localVarAxiosArgs = localVarAxiosParamCreator.staffClassesPost(
        props.classFilterOptions,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["UnifiedClassApi.staffClassesPost"]?.[
          localVarOperationServerIndex
        ]?.url;
      return createRequestFunction<StaffClassesResponseDTO>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client)
        .then((res) => {
          applyTransform("StaffClassesResponseDTO", res.data);
          return res;
        })
        .catch((a) => {
          notificationStore.evalErrorMessage(
            a,
            "An internal error has occured, please try again and contact us if the issue is not resolved!",
          );
          return a;
        });
    },
    /**
     * Signs up for a class
     * @param {StaffProcessWaitlistOffersRequestDTO} staffProcessWaitlistOffersRequestDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    staffClassesProcessWaitlistOffersPostRaw(
      props: staffClassesProcessWaitlistOffersPostParams,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      authStore.requireAuth([
        // authentication staff required
        "staff",
      ]);
      const localVarAxiosArgs =
        localVarAxiosParamCreator.staffClassesProcessWaitlistOffersPost(
          props.staffProcessWaitlistOffersRequestDTO,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          "UnifiedClassApi.staffClassesProcessWaitlistOffersPost"
        ]?.[localVarOperationServerIndex]?.url;

      return createRequestFunction<void>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client).catch((a) => {
        notificationStore.evalErrorMessage(
          a,
          "An internal error has occured, please try again and contact us if the issue is not resolved!",
        );
        return a;
      });
    },
    /**
     * Signs up for a class
     * @param {StaffClassSignupRequestDTO} staffClassSignupRequestDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    staffClassesSignupPostRaw(
      props: staffClassesSignupPostParams,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ClassSignupResponseDTO> {
      authStore.requireAuth([
        // authentication staff required
        "staff",
      ]);
      const localVarAxiosArgs =
        localVarAxiosParamCreator.staffClassesSignupPost(
          props.staffClassSignupRequestDTO,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["UnifiedClassApi.staffClassesSignupPost"]?.[
          localVarOperationServerIndex
        ]?.url;
      return createRequestFunction<ClassSignupResponseDTO>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client)
        .then((res) => {
          applyTransform("ClassSignupResponseDTO", res.data);
          return res;
        })
        .catch((a) => {
          notificationStore.evalErrorMessage(
            a,
            "An internal error has occured, please try again and contact us if the issue is not resolved!",
          );
          return a;
        });
    },
    /**
     * Create a guided sail instance for a specific timeslot
     * @param {string} timeslot
     * @param {number} personId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    staffGuidedSailCreateTimeslotPersonIdPostRaw(
      props: staffGuidedSailCreateTimeslotPersonIdPostParams,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<GuidedSailCreateInstanceResult> {
      authStore.requireAuth([
        // authentication staff required
        "staff",
      ]);
      const localVarAxiosArgs =
        localVarAxiosParamCreator.staffGuidedSailCreateTimeslotPersonIdPost(
          props.timeslot,
          props.personId,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          "UnifiedClassApi.staffGuidedSailCreateTimeslotPersonIdPost"
        ]?.[localVarOperationServerIndex]?.url;
      return createRequestFunction<GuidedSailCreateInstanceResult>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client)
        .then((res) => {
          applyTransform("GuidedSailCreateInstanceResult", res.data);
          return res;
        })
        .catch((a) => {
          notificationStore.evalErrorMessage(
            a,
            "An internal error has occured, please try again and contact us if the issue is not resolved!",
          );
          return a;
        });
    },
    /**
     * Get available guided sail time slots for a given month
     * @param {number} year
     * @param {number} month
     * @param {number} personId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    staffGuidedSailTimeslotsYearMonthPersonIdGetRaw(
      props: staffGuidedSailTimeslotsYearMonthPersonIdGetParams,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<GuidedSailTimeSlotsForDayDTO>> {
      authStore.requireAuth([
        // authentication staff required
        "staff",
      ]);
      const localVarAxiosArgs =
        localVarAxiosParamCreator.staffGuidedSailTimeslotsYearMonthPersonIdGet(
          props.year,
          props.month,
          props.personId,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          "UnifiedClassApi.staffGuidedSailTimeslotsYearMonthPersonIdGet"
        ]?.[localVarOperationServerIndex]?.url;
      return createRequestFunction<Array<GuidedSailTimeSlotsForDayDTO>>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client)
        .then((res) => {
          applyTransform("Array<GuidedSailTimeSlotsForDayDTO>", res.data);
          return res;
        })
        .catch((a) => {
          notificationStore.evalErrorMessage(
            a,
            "An internal error has occured, please try again and contact us if the issue is not resolved!",
          );
          return a;
        });
    },

    /**
     * Gets ao class instances
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apClassInstancesGet(
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<ApClassInstanceDTO>> {
      const localVarAxiosArgs =
        localVarAxiosParamCreator.apClassInstancesGet(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["UnifiedClassApi.apClassInstancesGet"]?.[
          localVarOperationServerIndex
        ]?.url;
      return createRequestFunction<Array<ApClassInstanceDTO>>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client)
        .then((res) => {
          applyTransform("Array<ApClassInstanceDTO>", res.data);
          return res;
        })
        .catch((a) => {
          notificationStore.evalErrorMessage(
            a,
            "An internal error has occured, please try again and contact us if the issue is not resolved!",
          );
          return a;
        });
    },
    /**
     * Gets jp class sections
     * @param {string} startDate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    jpClassSectionsGet(
      startDate: string,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<JpClassSectionDTO>> {
      const localVarAxiosArgs = localVarAxiosParamCreator.jpClassSectionsGet(
        startDate,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["UnifiedClassApi.jpClassSectionsGet"]?.[
          localVarOperationServerIndex
        ]?.url;
      return createRequestFunction<Array<JpClassSectionDTO>>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client)
        .then((res) => {
          applyTransform("Array<JpClassSectionDTO>", res.data);
          return res;
        })
        .catch((a) => {
          notificationStore.evalErrorMessage(
            a,
            "An internal error has occured, please try again and contact us if the issue is not resolved!",
          );
          return a;
        });
    },
    /**
     * Enroll as instructor for a class
     * @param {InstructorEnrollmentRequestDTO} instructorEnrollmentRequestDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    memberClassesInstructorEnrollPost(
      instructorEnrollmentRequestDTO: InstructorEnrollmentRequestDTO,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<string> {
      authStore.requireAuth([
        // authentication member required
        "member",
      ]);
      const localVarAxiosArgs =
        localVarAxiosParamCreator.memberClassesInstructorEnrollPost(
          instructorEnrollmentRequestDTO,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          "UnifiedClassApi.memberClassesInstructorEnrollPost"
        ]?.[localVarOperationServerIndex]?.url;
      return createRequestFunction<string>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client)
        .then((res) => {
          applyTransform("string", res.data);
          return res;
        })
        .catch((a) => {
          notificationStore.evalErrorMessage(
            a,
            "An internal error has occured, please try again and contact us if the issue is not resolved!",
          );
          return a;
        });
    },
    /**
     * Unenroll as instructor from a class
     * @param {InstructorEnrollmentRequestDTO} instructorEnrollmentRequestDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    memberClassesInstructorUnenrollPost(
      instructorEnrollmentRequestDTO: InstructorEnrollmentRequestDTO,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<string> {
      authStore.requireAuth([
        // authentication member required
        "member",
      ]);
      const localVarAxiosArgs =
        localVarAxiosParamCreator.memberClassesInstructorUnenrollPost(
          instructorEnrollmentRequestDTO,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          "UnifiedClassApi.memberClassesInstructorUnenrollPost"
        ]?.[localVarOperationServerIndex]?.url;
      return createRequestFunction<string>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client)
        .then((res) => {
          applyTransform("string", res.data);
          return res;
        })
        .catch((a) => {
          notificationStore.evalErrorMessage(
            a,
            "An internal error has occured, please try again and contact us if the issue is not resolved!",
          );
          return a;
        });
    },
    /**
     * Gets all classes with eligibility and signups
     * @param {ClassFilterOptions} classFilterOptions
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    memberClassesPost(
      classFilterOptions: ClassFilterOptions,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<ClassWithEligibilityDTO>> {
      authStore.requireAuth([
        // authentication member required
        "member",
      ]);
      const localVarAxiosArgs = localVarAxiosParamCreator.memberClassesPost(
        classFilterOptions,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["UnifiedClassApi.memberClassesPost"]?.[
          localVarOperationServerIndex
        ]?.url;
      return createRequestFunction<Array<ClassWithEligibilityDTO>>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client)
        .then((res) => {
          applyTransform("Array<ClassWithEligibilityDTO>", res.data);
          return res;
        })
        .catch((a) => {
          notificationStore.evalErrorMessage(
            a,
            "An internal error has occured, please try again and contact us if the issue is not resolved!",
          );
          return a;
        });
    },
    /**
     * Signs up for a class
     * @param {ClassSignupRequestDTO} classSignupRequestDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    memberClassesSignupPost(
      classSignupRequestDTO: ClassSignupRequestDTO,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ClassSignupResponseDTO> {
      authStore.requireAuth([
        // authentication member required
        "member",
      ]);
      const localVarAxiosArgs =
        localVarAxiosParamCreator.memberClassesSignupPost(
          classSignupRequestDTO,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["UnifiedClassApi.memberClassesSignupPost"]?.[
          localVarOperationServerIndex
        ]?.url;
      return createRequestFunction<ClassSignupResponseDTO>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client)
        .then((res) => {
          applyTransform("ClassSignupResponseDTO", res.data);
          return res;
        })
        .catch((a) => {
          notificationStore.evalErrorMessage(
            a,
            "An internal error has occured, please try again and contact us if the issue is not resolved!",
          );
          return a;
        });
    },
    /**
     * Create a guided sail instance for a specific timeslot
     * @param {string} timeslot
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    memberGuidedSailCreateTimeslotPost(
      timeslot: string,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<GuidedSailCreateInstanceResult> {
      authStore.requireAuth([
        // authentication member required
        "member",
      ]);
      const localVarAxiosArgs =
        localVarAxiosParamCreator.memberGuidedSailCreateTimeslotPost(
          timeslot,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          "UnifiedClassApi.memberGuidedSailCreateTimeslotPost"
        ]?.[localVarOperationServerIndex]?.url;
      return createRequestFunction<GuidedSailCreateInstanceResult>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client)
        .then((res) => {
          applyTransform("GuidedSailCreateInstanceResult", res.data);
          return res;
        })
        .catch((a) => {
          notificationStore.evalErrorMessage(
            a,
            "An internal error has occured, please try again and contact us if the issue is not resolved!",
          );
          return a;
        });
    },
    /**
     * Get available guided sail time slots for a given month
     * @param {number} year
     * @param {number} month
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    memberGuidedSailTimeslotsYearMonthGet(
      year: number,
      month: number,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<GuidedSailTimeSlotsForDayDTO>> {
      authStore.requireAuth([
        // authentication member required
        "member",
      ]);
      const localVarAxiosArgs =
        localVarAxiosParamCreator.memberGuidedSailTimeslotsYearMonthGet(
          year,
          month,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          "UnifiedClassApi.memberGuidedSailTimeslotsYearMonthGet"
        ]?.[localVarOperationServerIndex]?.url;
      return createRequestFunction<Array<GuidedSailTimeSlotsForDayDTO>>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client)
        .then((res) => {
          applyTransform("Array<GuidedSailTimeSlotsForDayDTO>", res.data);
          return res;
        })
        .catch((a) => {
          notificationStore.evalErrorMessage(
            a,
            "An internal error has occured, please try again and contact us if the issue is not resolved!",
          );
          return a;
        });
    },
    /**
     * Gets all classes
     * @param {ClassFilterOptions} classFilterOptions
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    publicClassesPost(
      classFilterOptions: ClassFilterOptions,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<ClassInstanceDTO>> {
      const localVarAxiosArgs = localVarAxiosParamCreator.publicClassesPost(
        classFilterOptions,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["UnifiedClassApi.publicClassesPost"]?.[
          localVarOperationServerIndex
        ]?.url;
      return createRequestFunction<Array<ClassInstanceDTO>>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client)
        .then((res) => {
          applyTransform("Array<ClassInstanceDTO>", res.data);
          return res;
        })
        .catch((a) => {
          notificationStore.evalErrorMessage(
            a,
            "An internal error has occured, please try again and contact us if the issue is not resolved!",
          );
          return a;
        });
    },
    /**
     * Enroll a person as instructor for a class (staff)
     * @param {StaffInstructorEnrollmentRequestDTO} staffInstructorEnrollmentRequestDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    staffClassesInstructorEnrollPost(
      staffInstructorEnrollmentRequestDTO: StaffInstructorEnrollmentRequestDTO,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<string> {
      authStore.requireAuth([
        // authentication staff required
        "staff",
      ]);
      const localVarAxiosArgs =
        localVarAxiosParamCreator.staffClassesInstructorEnrollPost(
          staffInstructorEnrollmentRequestDTO,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          "UnifiedClassApi.staffClassesInstructorEnrollPost"
        ]?.[localVarOperationServerIndex]?.url;
      return createRequestFunction<string>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client)
        .then((res) => {
          applyTransform("string", res.data);
          return res;
        })
        .catch((a) => {
          notificationStore.evalErrorMessage(
            a,
            "An internal error has occured, please try again and contact us if the issue is not resolved!",
          );
          return a;
        });
    },
    /**
     * Unenroll a person as instructor from a class (staff)
     * @param {StaffInstructorEnrollmentRequestDTO} staffInstructorEnrollmentRequestDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    staffClassesInstructorUnenrollPost(
      staffInstructorEnrollmentRequestDTO: StaffInstructorEnrollmentRequestDTO,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<string> {
      authStore.requireAuth([
        // authentication staff required
        "staff",
      ]);
      const localVarAxiosArgs =
        localVarAxiosParamCreator.staffClassesInstructorUnenrollPost(
          staffInstructorEnrollmentRequestDTO,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          "UnifiedClassApi.staffClassesInstructorUnenrollPost"
        ]?.[localVarOperationServerIndex]?.url;
      return createRequestFunction<string>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client)
        .then((res) => {
          applyTransform("string", res.data);
          return res;
        })
        .catch((a) => {
          notificationStore.evalErrorMessage(
            a,
            "An internal error has occured, please try again and contact us if the issue is not resolved!",
          );
          return a;
        });
    },
    /**
     * Gets all classes with eligibility and signups
     * @param {number} personId
     * @param {ClassFilterOptions} classFilterOptions
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    staffClassesPersonIdPost(
      personId: number,
      classFilterOptions: ClassFilterOptions,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<ClassWithEligibilitySingularDTO>> {
      authStore.requireAuth([
        // authentication staff required
        "staff",
      ]);
      const localVarAxiosArgs =
        localVarAxiosParamCreator.staffClassesPersonIdPost(
          personId,
          classFilterOptions,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["UnifiedClassApi.staffClassesPersonIdPost"]?.[
          localVarOperationServerIndex
        ]?.url;
      return createRequestFunction<Array<ClassWithEligibilitySingularDTO>>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client)
        .then((res) => {
          applyTransform("Array<ClassWithEligibilitySingularDTO>", res.data);
          return res;
        })
        .catch((a) => {
          notificationStore.evalErrorMessage(
            a,
            "An internal error has occured, please try again and contact us if the issue is not resolved!",
          );
          return a;
        });
    },
    /**
     * Gets all classes with availability (no person eligibility)
     * @param {ClassFilterOptions} classFilterOptions
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    staffClassesPost(
      classFilterOptions: ClassFilterOptions,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<StaffClassesResponseDTO> {
      authStore.requireAuth([
        // authentication staff required
        "staff",
      ]);
      const localVarAxiosArgs = localVarAxiosParamCreator.staffClassesPost(
        classFilterOptions,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["UnifiedClassApi.staffClassesPost"]?.[
          localVarOperationServerIndex
        ]?.url;
      return createRequestFunction<StaffClassesResponseDTO>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client)
        .then((res) => {
          applyTransform("StaffClassesResponseDTO", res.data);
          return res;
        })
        .catch((a) => {
          notificationStore.evalErrorMessage(
            a,
            "An internal error has occured, please try again and contact us if the issue is not resolved!",
          );
          return a;
        });
    },
    /**
     * Signs up for a class
     * @param {StaffProcessWaitlistOffersRequestDTO} staffProcessWaitlistOffersRequestDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    staffClassesProcessWaitlistOffersPost(
      staffProcessWaitlistOffersRequestDTO: StaffProcessWaitlistOffersRequestDTO,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      authStore.requireAuth([
        // authentication staff required
        "staff",
      ]);
      const localVarAxiosArgs =
        localVarAxiosParamCreator.staffClassesProcessWaitlistOffersPost(
          staffProcessWaitlistOffersRequestDTO,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          "UnifiedClassApi.staffClassesProcessWaitlistOffersPost"
        ]?.[localVarOperationServerIndex]?.url;

      return createRequestFunction<void>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client).catch((a) => {
        notificationStore.evalErrorMessage(
          a,
          "An internal error has occured, please try again and contact us if the issue is not resolved!",
        );
        return a;
      });
    },
    /**
     * Signs up for a class
     * @param {StaffClassSignupRequestDTO} staffClassSignupRequestDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    staffClassesSignupPost(
      staffClassSignupRequestDTO: StaffClassSignupRequestDTO,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ClassSignupResponseDTO> {
      authStore.requireAuth([
        // authentication staff required
        "staff",
      ]);
      const localVarAxiosArgs =
        localVarAxiosParamCreator.staffClassesSignupPost(
          staffClassSignupRequestDTO,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["UnifiedClassApi.staffClassesSignupPost"]?.[
          localVarOperationServerIndex
        ]?.url;
      return createRequestFunction<ClassSignupResponseDTO>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client)
        .then((res) => {
          applyTransform("ClassSignupResponseDTO", res.data);
          return res;
        })
        .catch((a) => {
          notificationStore.evalErrorMessage(
            a,
            "An internal error has occured, please try again and contact us if the issue is not resolved!",
          );
          return a;
        });
    },
    /**
     * Create a guided sail instance for a specific timeslot
     * @param {string} timeslot
     * @param {number} personId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    staffGuidedSailCreateTimeslotPersonIdPost(
      timeslot: string,
      personId: number,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<GuidedSailCreateInstanceResult> {
      authStore.requireAuth([
        // authentication staff required
        "staff",
      ]);
      const localVarAxiosArgs =
        localVarAxiosParamCreator.staffGuidedSailCreateTimeslotPersonIdPost(
          timeslot,
          personId,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          "UnifiedClassApi.staffGuidedSailCreateTimeslotPersonIdPost"
        ]?.[localVarOperationServerIndex]?.url;
      return createRequestFunction<GuidedSailCreateInstanceResult>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client)
        .then((res) => {
          applyTransform("GuidedSailCreateInstanceResult", res.data);
          return res;
        })
        .catch((a) => {
          notificationStore.evalErrorMessage(
            a,
            "An internal error has occured, please try again and contact us if the issue is not resolved!",
          );
          return a;
        });
    },
    /**
     * Get available guided sail time slots for a given month
     * @param {number} year
     * @param {number} month
     * @param {number} personId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    staffGuidedSailTimeslotsYearMonthPersonIdGet(
      year: number,
      month: number,
      personId: number,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<GuidedSailTimeSlotsForDayDTO>> {
      authStore.requireAuth([
        // authentication staff required
        "staff",
      ]);
      const localVarAxiosArgs =
        localVarAxiosParamCreator.staffGuidedSailTimeslotsYearMonthPersonIdGet(
          year,
          month,
          personId,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          "UnifiedClassApi.staffGuidedSailTimeslotsYearMonthPersonIdGet"
        ]?.[localVarOperationServerIndex]?.url;
      return createRequestFunction<Array<GuidedSailTimeSlotsForDayDTO>>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client)
        .then((res) => {
          applyTransform("Array<GuidedSailTimeSlotsForDayDTO>", res.data);
          return res;
        })
        .catch((a) => {
          notificationStore.evalErrorMessage(
            a,
            "An internal error has occured, please try again and contact us if the issue is not resolved!",
          );
          return a;
        });
    },
  };
};

/**
 * UnifiedClassApi - interface
 * @export
 * @interface UnifiedClassApi
 */
export interface UnifiedClassApiInterface {
  /**
   * Gets ao class instances
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UnifiedClassApiInterface
   */
  apClassInstancesGet(
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<Array<ApClassInstanceDTO>>;

  /**
   * Gets jp class sections
   * @param {string} startDate
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UnifiedClassApiInterface
   */
  jpClassSectionsGet(
    startDate: string,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<Array<JpClassSectionDTO>>;

  /**
   * Enroll as instructor for a class
   * @param {InstructorEnrollmentRequestDTO} instructorEnrollmentRequestDTO
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UnifiedClassApiInterface
   */
  memberClassesInstructorEnrollPost(
    instructorEnrollmentRequestDTO: InstructorEnrollmentRequestDTO,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<string>;

  /**
   * Unenroll as instructor from a class
   * @param {InstructorEnrollmentRequestDTO} instructorEnrollmentRequestDTO
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UnifiedClassApiInterface
   */
  memberClassesInstructorUnenrollPost(
    instructorEnrollmentRequestDTO: InstructorEnrollmentRequestDTO,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<string>;

  /**
   * Gets all classes with eligibility and signups
   * @param {ClassFilterOptions} classFilterOptions
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UnifiedClassApiInterface
   */
  memberClassesPost(
    classFilterOptions: ClassFilterOptions,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<Array<ClassWithEligibilityDTO>>;

  /**
   * Signs up for a class
   * @param {ClassSignupRequestDTO} classSignupRequestDTO
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UnifiedClassApiInterface
   */
  memberClassesSignupPost(
    classSignupRequestDTO: ClassSignupRequestDTO,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ClassSignupResponseDTO>;

  /**
   * Create a guided sail instance for a specific timeslot
   * @param {string} timeslot
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UnifiedClassApiInterface
   */
  memberGuidedSailCreateTimeslotPost(
    timeslot: string,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<GuidedSailCreateInstanceResult>;

  /**
   * Get available guided sail time slots for a given month
   * @param {number} year
   * @param {number} month
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UnifiedClassApiInterface
   */
  memberGuidedSailTimeslotsYearMonthGet(
    year: number,
    month: number,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<Array<GuidedSailTimeSlotsForDayDTO>>;

  /**
   * Gets all classes
   * @param {ClassFilterOptions} classFilterOptions
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UnifiedClassApiInterface
   */
  publicClassesPost(
    classFilterOptions: ClassFilterOptions,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<Array<ClassInstanceDTO>>;

  /**
   * Enroll a person as instructor for a class (staff)
   * @param {StaffInstructorEnrollmentRequestDTO} staffInstructorEnrollmentRequestDTO
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UnifiedClassApiInterface
   */
  staffClassesInstructorEnrollPost(
    staffInstructorEnrollmentRequestDTO: StaffInstructorEnrollmentRequestDTO,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<string>;

  /**
   * Unenroll a person as instructor from a class (staff)
   * @param {StaffInstructorEnrollmentRequestDTO} staffInstructorEnrollmentRequestDTO
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UnifiedClassApiInterface
   */
  staffClassesInstructorUnenrollPost(
    staffInstructorEnrollmentRequestDTO: StaffInstructorEnrollmentRequestDTO,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<string>;

  /**
   * Gets all classes with eligibility and signups
   * @param {number} personId
   * @param {ClassFilterOptions} classFilterOptions
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UnifiedClassApiInterface
   */
  staffClassesPersonIdPost(
    personId: number,
    classFilterOptions: ClassFilterOptions,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<Array<ClassWithEligibilitySingularDTO>>;

  /**
   * Gets all classes with availability (no person eligibility)
   * @param {ClassFilterOptions} classFilterOptions
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UnifiedClassApiInterface
   */
  staffClassesPost(
    classFilterOptions: ClassFilterOptions,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<StaffClassesResponseDTO>;

  /**
   * Signs up for a class
   * @param {StaffProcessWaitlistOffersRequestDTO} staffProcessWaitlistOffersRequestDTO
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UnifiedClassApiInterface
   */
  staffClassesProcessWaitlistOffersPost(
    staffProcessWaitlistOffersRequestDTO: StaffProcessWaitlistOffersRequestDTO,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<void>;

  /**
   * Signs up for a class
   * @param {StaffClassSignupRequestDTO} staffClassSignupRequestDTO
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UnifiedClassApiInterface
   */
  staffClassesSignupPost(
    staffClassSignupRequestDTO: StaffClassSignupRequestDTO,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ClassSignupResponseDTO>;

  /**
   * Create a guided sail instance for a specific timeslot
   * @param {string} timeslot
   * @param {number} personId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UnifiedClassApiInterface
   */
  staffGuidedSailCreateTimeslotPersonIdPost(
    timeslot: string,
    personId: number,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<GuidedSailCreateInstanceResult>;

  /**
   * Get available guided sail time slots for a given month
   * @param {number} year
   * @param {number} month
   * @param {number} personId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UnifiedClassApiInterface
   */
  staffGuidedSailTimeslotsYearMonthPersonIdGet(
    year: number,
    month: number,
    personId: number,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<Array<GuidedSailTimeSlotsForDayDTO>>;
}
